export default __webpack_public_path__ + "static/media/app-bar-account.d57cdc87.svg";